import { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import {
  FaLinkedin,
  FaRegEnvelopeOpen,
  FaWhatsappSquare,
  FaGithubSquare,
} from "react-icons/fa";

import { BrowserRouter as Router } from "react-router-dom";
import logo from "../assets/img/logo.svg";

export const NavBar = () => {
  const [activeLink, setActiveLink] = useState("home");
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const onUpdateActiveLink = (value) => {
    setActiveLink(value);
  };

  return (
    <Router>
      <Navbar expand="md" className={scrolled ? "scrolled" : ""}>
        <Container>
          <Navbar.Brand href="/">
            <img src={logo} alt="Logo" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav">
            <span className="navbar-toggler-icon"></span>
          </Navbar.Toggle>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link
                href="#home"
                className={
                  activeLink === "home" ? "active navbar-link" : "navbar-link"
                }
                onClick={() => onUpdateActiveLink("home")}
              >
                Home
              </Nav.Link>
              <Nav.Link
                href="#skills"
                className={
                  activeLink === "skills" ? "active navbar-link" : "navbar-link"
                }
                onClick={() => onUpdateActiveLink("skills")}
              >
                Skills
              </Nav.Link>
              <Nav.Link
                href="#project"
                className={
                  activeLink === "project"
                    ? "active navbar-link"
                    : "navbar-link"
                }
                onClick={() => onUpdateActiveLink("project")}
              >
                Projects
              </Nav.Link>
              <Nav.Link
                href="#contact"
                className={
                  activeLink === "contact"
                    ? "active navbar-link"
                    : "navbar-link"
                }
                onClick={() => onUpdateActiveLink("contact")}
              >
                Contact
              </Nav.Link>
            </Nav>
            <span className="navbar-text">
              <div className="social-icon">
                <a href="https://www.linkedin.com/in/muhammad-immad-7b4553207/">
                  {" "}
                  <FaLinkedin />{" "}
                </a>
                <a href="https://mail.google.com/mail/u/0/#inbox?compose=CllgCJqTgHnFmBsFwMCtzBbVWdsFbJzQZhWVlRHnTSHtvvKVfqtKMfJFzNjsjJdKqxDvGZRVFGB">
                  {" "}
                  <FaRegEnvelopeOpen />{" "}
                </a>
                <a href="https://wa.me/03363510768">
                  {" "}
                  <FaWhatsappSquare />{" "}
                </a>
                <a href="https://github.com/itsimmad">
                  {" "}
                  <FaGithubSquare />{" "}
                </a>
              </div>
            </span>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </Router>
  );
};
